/**
 * `W5-T07` §4.10 — back from Checkout, the billing page re-reads the subscription for a minute.
 *
 * Checkout redirects as soon as the payment succeeds, and `customer.subscription.created` reaches us a
 * few seconds later, so the page asks again every five seconds while there is no subscription yet or
 * its first payment is pending, and stops after sixty. It is `W5-T01`'s watch, with its window and its
 * rules (the loader is what polls; a tick is skipped while the tab is hidden or the router is busy).
 * Returns `false` once the minute has run out, so the page can say Stripe is still confirming.
 */
import { useWatch, WATCH_EVERY_MS, WATCH_FOR_MS } from '../payouts/watch.js';

export function useBillingWatch(active: boolean): boolean {
  return useWatch(active, { everyMs: WATCH_EVERY_MS, forMs: WATCH_FOR_MS });
}
